import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { renderIf } from 'core/utils';

const BasicTextAreaTemplate = defaultTemplate(({ field, t, rows, disabled, style, onKeyDown, isFocus }) => {
    const { placeholder, onChange, ...otherProps } = field.bind();
   
    const handleChange = (e) => {
        const inputElement = e.target;

        if (onChange) {
            onChange({
                ...e,
                target: { ...inputElement, value: inputElement.value }
            });
        }
    };

    const requiredMark = field.rules && field.rules.indexOf('required') !== -1 ? <span className="validation__mark">*</span> : null;

    return (
        <div>
            <label className="form__group__label" htmlFor={field.id}>{t(field.label)}{requiredMark}</label>
            {renderIf(field.localizedError)(<div className="validation__message"> <i className="u-icon u-icon--xsml u-icon--warning u-mar--right--tny"></i>{field.localizedError}</div>)}
            <textarea className="input input--textarea" rows={rows != undefined ? rows : 5}
                {...otherProps}
                placeholder={t(placeholder)} disabled={disabled} style={style}
                onKeyDown={onKeyDown && ((e) => onKeyDown(e))}
                autoFocus={isFocus}
            onChange={handleChange}
            />
        </div>
    )
});

export default BasicTextAreaTemplate;
